export default function confirm(config){
  let okText = this.$t('baseVO.confirm');
  let cancelText = this.$t('baseVO.cacel');
  this.$confirm({
    title: '',
    content: config.content,
    icon:h=> config.icon?<pt-icon type="icon-GroupCopy2"></pt-icon>:<a-icon type="question-circle" />,
    okText: config.okText || okText,
    cancelText: config.cancelText || cancelText,
    okType: config.okType || 'primary',
    closable:config.closable || true,
    autoFocusButton:config.autoFocusButton || 'ok',
    onOk() {
      config.onOk()
    },
    onCancel() {
      config.onCancel()
    },
  });
}
